var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vacancies"},_vm._l((_vm.vacanciesList),function(vacancy){return _c('widget-link',{key:vacancy.id,attrs:{"item":vacancy},on:{"closeMenu":function($event){return _vm.$emit('closeMenu')}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }